import React, {FunctionComponent} from 'react';
import cn from 'classnames';
import {createUseStyles} from 'react-jss';
import {IconProps} from './IconProps';


/**
 * Abstract Icon component used to create specific icons
 * @param className {string|undefined} Additional classes
 * @param height {string|undefined} Height
 * @param title {string|undefined} Title
 * @param children {ReactElement} The content of 'path'
 * @constructor
 */
const Icon: FunctionComponent<IconProps> = ({
  className, height = '1rem', title, children,
}) => {
  const styles = useStyles();
  const viewBox = '0 0 20 20';

  return (
    <svg className={cn('inline-block', className, styles.icon)}
      xmlns="http://www.w3.org/2000/svg" height={height}
      viewBox={viewBox}
      aria-labelledby={title}>
      <path fillRule="evenodd" clipRule="evenodd" fill="currentColor" d={children?.toString()}/>
    </svg>
  );
};

export default Icon;
const useStyles = createUseStyles({
  icon: {
    verticalAlign: '-0.125em',
  },
});
